import Vue from 'vue'
import { isObject } from './types.js'

const bus = new Vue()
const cookie_key = 'shiseido_skincare_consultation_2018'
const contentAssetPath = (path) => {
    if (window.location.hostname.match(/localhost/i)) {
        return path
    } else if (typeof path !== 'undefined' && path !== null && typeof path === 'string' && window.hasOwnProperty('composed_skincare_consultation_content_asset_path')) {
        return window.composed_skincare_consultation_content_asset_path.concat(path)
    }
}

export {
    bus,
    cookie_key,
    isObject,
    contentAssetPath,
}


// WEBPACK FOOTER //
// ./source/app/js/utilities/index.js